import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { setTableColumnSelection } from '../store/redux-slices/uiConfig'

const useTableColumnSelection = (columns, id) => {
  const dispatch = useDispatch()
  const columnSelections = useSelector((state) => state?.uiConfig?.tableColumnSelections[id])

  useEffect(() => {
    // Check if column selections are not available in the Redux store,
    // then initialize it by dispatching the setTableColumnSelection action.
    if (!columnSelections) {
      dispatch(setTableColumnSelection({
        id,
        columnSelections: [...columns]
      }))
    }
  }, [columnSelections])

  return {
    columnSelections
  }
}

export default useTableColumnSelection
